import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchQuestionnaireQuestions } from 'actions/questionnaire';
import { fetchQuestionnaireQuestions as apiFetchQuestionnaireQuestions, reorderQuestions } from 'api/questionnaire';
import { Button, NonIdealState, Intent } from '@blueprintjs/core';
import { AppToaster } from 'components/AppToaster';

import QuestionnaireAddQuestionDrawer from 'containers/Manage-Questionnaire/questionnaire/local/QuestionnaireAddQuestionDrawer';

import colors from 'utils/colors';
import Pagination from 'components/pagination';
import { FlexRow } from 'components/styled-components';
import { QuestionnaireControls } from 'components/forms/questionnaire-management/controls';
import QuestionnaireTableRow from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireTableRow';
import FilterMenu from 'containers/Manage-Questionnaire/questionnaire/FilterMenu';
import Loading from 'components/loading';

import QuestionReorderDrawer from 'containers/Manage-Questionnaire/questionnaire/local/QuestionReorderDrawer';

const initialState = {
  questionnaireIndex: null,
  currentPage: 0,
  perPage: 10,
  searchQuery: '',
  addingQuestionnaireQuestion: false,
  filter: '',
  filterField: null,
  displayFilter: '',
  questionDrawerOpen: false,
  gettingOrderQuestions: false,
  orderQuestions: [],
};

class QuestionnaireTable extends Component {
  state = { ...initialState };
  componentDidMount() {
    this.fetchQuestions();
	this.getOrderQuestions();
  }

  componentWillUnmount() {
    this.setState({ ...initialState });
  }

  getOrderQuestions = () => {
	this.setState({ gettingOrderQuestions: true });
	const params = this.buildParams();
	apiFetchQuestionnaireQuestions({
		...params,
		start: 0,
		limit: 999,
	  })
		.then(results => {
			this.setState({
				gettingOrderQuestions: false,
				orderQuestions: results.data.result
			});
		})
  }

  buildParams = () => {
    const { filter, filterField, searchQuery } = this.state;
    return {
      ...(filter && {
        [filterField]: filter.value,
      }),
      ...(searchQuery && { searchQuery }),
    };
  };

  fetchQuestions = () => {
    const params = this.buildParams();
    const { currentPage, perPage } = this.state;
    this.props.fetchQuestionnaireQuestions({
      ...params,
      start: currentPage * perPage,
      limit: perPage,
    });
  };

  openQuestionnaireAddQuestion = () =>
    this.setState({ addingQuestionnaireQuestion: true });
  closeQuestionnaireAddQuestion = () =>
    this.setState({ addingQuestionnaireQuestion: false });

  handlePageClick = currentPage => {
    this.setState({ currentPage }, () => {
      this.fetchQuestions();
    });
  };

  handlePerPageChange = perPage => {
    this.setState({ perPage: perPage.value, currentPage: 0 }, () => {
      this.fetchQuestions();
    });
  };

  handleSearch = searchQuery =>
    this.setState({ searchQuery, currentPage: 0 }, () => this.fetchQuestions());

  handleChangeFilter = (filter, filterField, displayFilter) => {
    this.setState({ filter, filterField, displayFilter, currentPage: 0 }, () =>
      this.fetchQuestions()
    );
  };

  clearFilters = () => {
    this.setState(
      { filter: null, filterField: null, displayFilter: '', currentPage: 0 },
      () => this.fetchQuestions()
    );
  };

  setQuestionnaireIndex = prescreenIndex => this.setState({ prescreenIndex });

  setQuestionReorderDrawer = (toggle) => {
	this.getOrderQuestions();
	this.setState({questionDrawerOpen: toggle});
  };

  handleSaveQuestionOrder = (reorderedList) => {
	  reorderQuestions(reorderedList)
		.then(res => {
			//close drawer
			// this.setQuestionReorderDrawer(false);
			//toast the message
			AppToaster.show({
				message: res.data.message,
				intent: Intent.SUCCESS,
			});
			//repopulate categories
			setTimeout(this.getOrderQuestions, 300); //some how the network is too fast making this go off before the db finishes from the previous thing...
		})
		.catch(error => {
			AppToaster.show({
				message: error.response.data.message,
				intent: Intent.DANGER,
			});
		});
  }

  render() {
    const { questions, isFetching, categories, questionTypes } = this.props;
    const { searchQuery, questionDrawerOpen, gettingOrderQuestions, orderQuestions } = this.state;

    return (
      <>
        <FlexRow>
          <div style={{ width: '70%', marginLeft: '1rem' }}>
            <QuestionnaireControls
              value={searchQuery}
              handleSearch={this.handleSearch}
              active={1}
            >
              <FilterMenu
                categories={categories}
                questionTypes={questionTypes}
                questionStatus={this.props.questionStatus}
                handleChangeFilter={this.handleChangeFilter}
                selectedFilter={this.state.filter}
                displayFilter={this.state.displayFilter}
                clearFilters={this.clearFilters}
              />
            </QuestionnaireControls>
          </div>

          <div>
            <Button
              minimal
              onClick={this.openQuestionnaireAddQuestion}
              style={{
                color: colors.primary,
                fontSize: '0.9rem',
                marginRight: '3rem',
              }}
              text="+ ADD QUESTION"
            />
            <QuestionnaireAddQuestionDrawer
              closeDrawer={this.closeQuestionnaireAddQuestion}
              openDrawer={this.openQuestionnaireAddQuestion}
              isOpen={this.state.addingQuestionnaireQuestion}
              categories={categories}
              questionTypes={questionTypes}
              fetchQuestionnaireQuestions={this.fetchQuestions}
            />
			<>
				<Button
					minimal
					onClick={() => this.setQuestionReorderDrawer(true)}
					style={{
						color: colors.primary,
						fontSize: '0.9rem',
						marginRight: '3rem',
					}}
					text="Re-Order Questions"
				/>
				<QuestionReorderDrawer
					closeDrawer={() => this.setQuestionReorderDrawer(false)}
					openDrawer={() => this.setQuestionReorderDrawer(true)}
					isOpen={questionDrawerOpen}
					list={orderQuestions}
					handleSaveOrder={this.handleSaveQuestionOrder}
					isLoading={gettingOrderQuestions}
					displayCategories={categories}
					questionTypes={questionTypes}
				/>
  			</>
          </div>
        </FlexRow>
        {isFetching ? (
          <Loading size={100} />
        ) : questions.totalCount ? (
          questions.result.map((question, i) => (
            <QuestionnaireTableRow
              question={question}
              index={i}
              key={`${i}-${question.questionID}`}
              total={questions.totalCount}
              setQuestionnaireIndex={this.setQuestionnaireIndex}
              currentIndex={this.state.questionnaireIndex}
              fetchQuestionnaireQuestions={this.fetchQuestions}
              categories={categories}
              questionTypes={questionTypes}
              searchQuery={searchQuery}
            />
          ))
        ) : (
          <NonIdealState
            icon={searchQuery ? 'search' : 'error'}
            title="No results found"
            description={
              searchQuery
                ? 'Your search did not match any questions'
                : 'There was an error fetching the questions.'
            }
          />
        )}

        <Pagination
          numRecords={questions.totalCount}
          perPage={this.state.perPage}
          currentPage={this.state.currentPage}
          onPageClick={this.handlePageClick}
          handlePerPageChange={this.handlePerPageChange}
        />
      </>
    );
  }
}
const mapStateToProps = state => ({
  questions: state.questionnaire.questions,
  isFetching: state.questionnaire.isFetching,
  questionTypes: state.utils.questionTypes,
  categories: state.utils.categories,
  questionStatus: state.utils.questionStatus,
});

QuestionnaireTable = connect(
  mapStateToProps,
  {
    fetchQuestionnaireQuestions,
  }
)(QuestionnaireTable);

export default QuestionnaireTable;
